module.exports = __webpack_public_path__ + "static/jquery-4cc01860cb24d8f47769a56deb495e8e.png";